import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { PageNotFoundComponent } from "./@core/components/page-not-found/page-not-found.component";
import { LoadApplicationGuard } from "./@core/guards/load-application.guard";
import { LoadMainApplicationGuard } from "./@core/guards/load-main-application.guard";
import { loadCustomerResolver } from "./@core/resolvers/load-customer.resolver";
import { AuthenticationGuard } from "./authentication/authentication.guard";
import { LoggedInAuthenticationGuard } from "./authentication/logged-in-auth.guard";
import { LoginComponent } from "./authentication/login.component";

const routes: Routes = [
	{
		path: ":orgUuid/login",
		component: LoginComponent,
		canActivate: [LoadApplicationGuard, LoggedInAuthenticationGuard],
		data: { title: "Login" },
	},
	{
		path: ":orgUuid/:customerUuid",
		canActivate: [LoadMainApplicationGuard, AuthenticationGuard],
		resolve: {
			customerInfo: loadCustomerResolver,
		},
		children: [
			{
				path: "",
				loadChildren: () =>
					import("./application-main.routes").then(m => m.APPLICATION_MAIN_ROUTES),
			},
			{
				path: "**",
				component: PageNotFoundComponent,
				data: { title: "Not Found" },
			},
		],
	},
	{
		path: "**",
		component: PageNotFoundComponent,
		data: { title: "Not Found" },
	},
	{
		path: "",
		component: PageNotFoundComponent,
		data: { title: "Organization / Customer Not Found" },
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { paramsInheritanceStrategy: "always" })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
